export default __webpack_public_path__ + "static/media/personality_ISTj.88e21da8.png";